/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef, useMemo } from 'react';
import * as Yup from 'yup';
import { useSelector } from 'react-redux';
import {
  Divider,
  Stack,
  FormControl,
  Select,
  MenuItem,
  IconButton,
  TextField,
  InputLabel,
  Typography,
  Grid,
  Paper,
  Box,
  FormHelperText,
  Tooltip,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { LoadingButton } from '@mui/lab';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Autocomplete from '@mui/material/Autocomplete';
import dayjs from 'dayjs';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import TimerTwoToneIcon from '@mui/icons-material/TimerTwoTone';
import { useNavigate, useParams } from 'react-router-dom';
import { styled } from '@mui/system';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { toast } from 'react-toastify';
import { Form, FormikProvider, useFormik } from 'formik';
import { getProjectById } from '../../../../../services/projectService';
import { getAllUsers } from '../../../../../services/teamService';
import { getSectionsByProjectId } from '../../../../../services/sectionService';
import { createTask, getAllTasksByProjectId, updateTask } from '../../../../../services/taskService';
import { isAdmin, isStakeholder } from '../../../../../utils/share';
import { useProject } from '../../../Layout/header/context';
import SectionFormModal from './SectionFormModal';
import { AddMemberModal } from '..';
import { INITIAL_TASK_FORM_STATE } from './constants';

function ProjectAddTask({
  hideProjectName,
  onAddTask,
  selectedTask,
  project,
  projectName,
  sectionId,
  close,
  action,
  onSubmit,
}) {
  // console.log('selectedTask', selectedTask);
  const { id } = useParams();
  const accountData = useSelector((state) => state?.login?.user || null);
  const userId = accountData?.id;
  const [employeeList, setEmployeeList] = useState([]);
  const [parentTask, setParentTask] = useState([]);
  const [taskName, setTaskName] = useState('');

  // const [filteredParentTask, setFilteredParentTask] = useState([]);
  const [sectionList, setSectionList] = useState([{}]);
  const [addSectionModal, setAddSectionModal] = useState(false);
  const [addMemberModal, setAddMemberModal] = useState(false);
  const [projectDetails, setProjectDetails] = useState({});

  const { projectDetails: projectDetailsContext } = useProject();
  const navigate = useNavigate();
  // const location = useLocation();
  const classes = useStyles();
  const defaultFormData = useRef(INITIAL_TASK_FORM_STATE());

  const projectId = selectedTask?.projectId || project?.id || id || projectDetailsContext?.id;

  const handleClose = () => {
    setValues(INITIAL_TASK_FORM_STATE());
    setTouched({});
    close();
  };

  const createTaskSchema = Yup.object({
    taskName: Yup.string().required('Task Name is required').min(2, 'Too Short'),
    userId: Yup.number().required('Employee is required'),
    sectionId: Yup.number().required('Section is required'),
    startDate: Yup.date().required('Start date is required').typeError('Enter valid start date'),
    endDate: Yup.date()
      .min(Yup.ref('startDate'), "End date can't be before start date")
      .required('End date is required')
      .typeError('Enter valid end date'),
    // description: Yup.string().required("Description is required"),
    plannedHours: Yup.number()
      .min(0, 'Please enter valid Hours')
      .typeError('Planned Hours must be a number')
      .required('Planned Hours is required'),
    status: Yup.string().required('Status is required'),
    taskType: Yup.string().required('Task Type is required'),
    parentTaskId: Yup.number().nullable(),
    issueType: Yup.string().when('taskType', {
      is: 'Issue',
      then: Yup.string().required('Issue Type is required').nullable("Issue Type can't be empty"),
      otherwise: Yup.string().nullable(),
    }),
    isBillable: Yup.boolean().required('Please select if the task is billable'),
  });

  const formik = useFormik({
    initialValues: defaultFormData.current,
    validationSchema: createTaskSchema,
    onSubmit: (values) => {
      handleAPICall(values);
    },
  });

  const {
    touched,
    handleSubmit,
    setValues,
    submitForm,
    errors,
    isSubmitting,
    setSubmitting,
    getFieldProps,
    setTouched,
    setFieldValue,
    values,
  } = formik;

  // const filterTask = (value) => {
  //   const filtered = parentTask.filter((option) => {
  //     if (!option || !option.taskName) return false;
  //     return option.taskName.toLowerCase().includes(value.toLowerCase().trim());
  //   });
  //   console.log('filtered', filtered);
  //   setFilteredParentTask(filtered);
  // };
  // const filterTask = (value) => {
  //   console.log('Filtering for:', value);
  //   const searchTerm = value.toLowerCase().trim();
  //   const filtered = parentTask.filter((option) => {
  //     if (!option || !option.taskName) return false;
  //     const isMatch = option.taskName.toLowerCase().includes(searchTerm);
  //     console.log(`Option: ${option.taskName}, Match: ${isMatch}`);
  //     return isMatch;
  //   });
  //   console.log('Filtered results:', filtered);
  //   setFilteredParentTask(filtered);
  // };

  // useEffect(() => {
  // const filtered = parentTask.filter((option) => {
  //   if (!option || !option.taskName) return false;
  //   return option.taskName.toLowerCase().includes(inputValue.toLowerCase().trim());
  // });
  // console.log('filtered', filtered);
  // setFilteredParentTask(filtered);
  // }, [parentTask]);

  useEffect(() => {
    if (values.taskType !== 'Issue') {
      setFieldValue('parentTaskId', null);
      setFieldValue('issueType', null);
    }
  }, [values.taskType, setFieldValue]);

  const handleUpdate = () => {
    defaultFormData.current = {
      taskName: selectedTask.taskName,
      plannedHours: selectedTask.plannedHours,
      parentTaskId: selectedTask.parentTaskId,
      type: selectedTask.type,
      userId: selectedTask.userId,
      sectionId: selectedTask.sectionId,
      startDate: selectedTask.startDate,
      endDate: selectedTask.endDate,
      description: selectedTask.description,
      status: selectedTask.status,
      issueType: selectedTask.issueType,
      isBillable: selectedTask.isBillable,
    };

    const formattedStartDate = selectedTask.startDate ? dayjs(selectedTask.startDate).format('YYYY-MM-DD') : null;
    const formattedEndDate = selectedTask.endDate ? dayjs(selectedTask.endDate).format('YYYY-MM-DD') : null;

    setValues({
      taskName: selectedTask.taskName,
      plannedHours: selectedTask.plannedHours,
      parentTaskId: selectedTask.parentTaskId,
      taskType: selectedTask.taskType,
      userId: selectedTask.userId,
      sectionId: selectedTask.sectionId,
      startDate: formattedStartDate,
      endDate: formattedEndDate,
      description: selectedTask.description,
      status: selectedTask.status,
      issueType: selectedTask.issueType,
      isBillable: selectedTask.isBillable,
    });
  };
  const cleanupPayload = (payload) => {
    const cleanedPayload = {};
    Object.entries(payload).forEach(([key, value]) => {
      if (value !== '' && (value !== null || key === 'parentTaskId')) {
        cleanedPayload[key] = value;
      }
    });
    return cleanedPayload;
  };
  const handleAPICall = async (values) => {
    const cleanedValues = cleanupPayload(values);
    try {
      let Task;
      if (action === 'create') {
        // Remove the parentTask field
        delete cleanedValues.parentTask;
        Task = await createTask({ ...cleanedValues, projectId });
        if (onAddTask) onAddTask(Task.data);
      } else if (action === 'update') {
        Task = await updateTask(selectedTask.id, { ...cleanedValues, projectId });
      }
      toast.success(Task?.data?.message);

      if (onSubmit) onSubmit();
    } catch (error) {
      toast.error(error?.response?.data?.message ?? error.message);
    } finally {
      setSubmitting(false);
      handleClose();
    }
  };

  const handleNavigate = () => {
    if (selectedTask.userId !== userId) {
      toast.info(`This is not your task`);
    } else if (
      selectedTask.status === 'To Do' ||
      selectedTask.status === 'In Progress' ||
      selectedTask.status === 'Not Started'
    ) {
      navigate('/timetracker', {
        state: {
          taskName: selectedTask.taskName,
          projectId: selectedTask.projectId,
          id: selectedTask.id,
          userId: selectedTask.userId,
        },
      });
    } else if (selectedTask.status === 'Completed' || selectedTask.status === 'Blocked') {
      toast.info(`Task status is ${selectedTask.status}.`);
    }
    close();
  };

  const fetchEmployee = async () => {
    try {
      const Projects = await getProjectById(projectId);
      const membersList = Projects?.data?.data?.projectmember.map((member) => member?.userId);
      const employees = await getAllUsers();
      const filteredEmployees = employees?.data?.data
        .filter((emp) => membersList.includes(emp.id))
        .sort((a, b) => a.userName.localeCompare(b.userName));
      setEmployeeList(filteredEmployees);
    } catch (e) {
      toast.error(e.message);
    }
  };

  const hanldeAddSectionClick = () => {
    setAddSectionModal(true);
  };

  const handleCloseAddSection = () => {
    setAddSectionModal(false);
  };

  const hanldeAddMemberClick = () => {
    setAddMemberModal(true);
  };

  const handleCloseAddMember = () => {
    setAddMemberModal(false);
  };

  const onAddSection = (section) => {
    setSectionList((prev) => [...prev, section]);
    setFieldValue('sectionId', section?.id);
    setAddSectionModal(false);
  };

  const onAddMember = async () => {
    // member is coming as an argument
    await fetchEmployee();
    // setFieldValue('userId', member?.id);
    setAddMemberModal(false);
  };

  const fetchAllProjectTasks = async () => {
    try {
      const taskListResponse = await getAllTasksByProjectId({
        projectId,
        pageSize: 5,
        wantCompletedTask: true,
        globalFilter: taskName,
      });
      const tasks = (taskListResponse?.data?.rows || []).filter((task) => task.id !== selectedTask?.id);

      if (selectedTask?.parentTask?.id !== null && selectedTask?.parentTask?.id !== undefined) {
        // Check if parent task already exists based on id
        const parentTaskExists = tasks.some((task) => task.id === selectedTask?.parentTask.id);

        // Only add parent task if it doesn't already exist
        const newParentTasks = parentTaskExists ? tasks : [...tasks, selectedTask?.parentTask];
        setParentTask(newParentTasks);
      } else {
        setParentTask(tasks);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  useEffect(() => {
    if (sectionId) setFieldValue('sectionId', sectionId);
  }, [sectionId, setFieldValue]);

  useEffect(() => {
    const fetchSections = async () => {
      try {
        const response = await getSectionsByProjectId(projectId, { orderBy: 'name', order: 'ASC' });
        setSectionList(response?.data?.data?.rows);
      } catch (error) {
        const errorMessage =
          error?.response?.data?.message ||
          '"Oops! Something went wrong while fetching the section list. Please try again later."';
        toast.error(errorMessage);
      }
    };

    fetchEmployee();
    fetchSections();
    fetchAllProjectTasks();
    if (action === 'update') {
      handleUpdate();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchAllProjectTasks();
  }, [taskName]);

  useEffect(() => {
    const fetchProjectDetails = async () => {
      try {
        const Projects = await getProjectById(projectId);
        setProjectDetails(Projects?.data?.data);
      } catch (e) {
        toast.error(e.message);
      }
    };

    if (projectId) fetchProjectDetails();
  }, [projectId]);

  useEffect(() => {
    // Set tabindex for all elements within the Quill toolbar
    const toolbarElements = document.querySelectorAll('.ql-toolbar *');
    toolbarElements.forEach((element) => {
      element.setAttribute('tabindex', '-1');
    });
  }, []);

  // const projectRole =
  //   projectDetails?.projectmember?.find((data) => data.userId === userId)?.projectRoles?.roleName ?? '';

  const projectRole = useMemo(
    () => projectDetails?.projectmember?.find((data) => data.userId === userId)?.projectRoles?.roleName ?? '',
    [projectDetails, userId]
  );

  // const consumedHrs = projectDetails?.projectmember?.reduce((sum, member) => sum + member?.totalTime / 3600, 0) ?? 0;

  const consumedHrs = useMemo(
    () => projectDetails?.projectmember?.reduce((sum, member) => sum + member?.totalTime / 3600, 0) ?? 0,
    [projectDetails]
  );

  const isTeamMemberRole = !isAdmin() && projectRole === 'Team Members';

  useEffect(() => {
    if (isTeamMemberRole && action === 'create') setFieldValue('userId', accountData?.id);
  }, [isTeamMemberRole, action, accountData?.id, setFieldValue]);

  return (
    <>
      {!isStakeholder() && (
        <Box>
          <Stack direction="row" sx={{ justifyContent: 'space-between' }}>
            <Typography
              variant="h5"
              align="center"
              sx={{
                m: '8px 0',
                color: '#999',
                fontWeight: '600',
                fontSize: { xs: '.9rem', sm: '1rem', md: '1.25rem' },
                paddingLeft: '24px',
              }}
            >
              {action === 'create' ? 'Create a New Task' : action === 'update' ? 'Edit a Task' : ''}
            </Typography>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                mb: 1,
              }}
            >
              {action === 'update' ? (
                <Tooltip title="go to timetracker">
                  <IconButton aria-label="expand row" sx={{ fontSize: ' xx-large' }} onClick={handleNavigate}>
                    <TimerTwoToneIcon fontSize=" xx-large" />
                  </IconButton>
                </Tooltip>
              ) : null}
              <Tooltip title="back">
                <IconButton
                  aria-label="expand row"
                  size="small"
                  // sx={{ marginRight: 'auto' }}
                  onClick={handleClose}
                >
                  <ArrowForwardIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </Box>
          </Stack>
          <Divider sx={{ mb: 1 }} />
          <FormikProvider value={formik}>
            <Form onSubmit={handleSubmit} style={{ marginTop: '.5rem' }}>
              <Stack direction="column" spacing={4} style={{ paddingRight: '24px' }}>
                <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                  <Grid item xs={12}>
                    <FormControl className={classes.width}>
                      <TextField
                        autoFocus
                        size="small"
                        label="Task name"
                        placeholder="Add task name"
                        variant="outlined"
                        {...getFieldProps('taskName')}
                        fullWidth
                        error={touched.taskName && Boolean(errors.taskName)}
                        helperText={touched.taskName && errors.taskName}
                        onChange={(e) => {
                          setFieldValue('taskName', e.target.value);
                          e?.stopPropagation();
                        }}
                      />
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} className={classes.quillGrid}>
                    <ReactQuill
                      theme="snow"
                      name="description"
                      onChange={(value) => {
                        setFieldValue('description', value);
                      }}
                      value={values?.description}
                      modules={modules}
                      formats={formats}
                      style={{
                        border: touched.description && errors.description ? '1px solid #FF4842' : undefined,
                        borderRadius: '6px',
                        fontFamily: '"Public Sans", sans-serif',
                        fontSize: '16px',
                      }}
                      placeholder="Add task description..."
                    />
                    {touched.description && errors.description && (
                      <div style={{ color: 'red', marginLeft: '14px', fontSize: '.75rem' }}>{errors.description}</div>
                    )}
                  </Grid>

                  {!hideProjectName && (
                    <>
                      <StyledGrid item xs={6}>
                        <FormControl sx={{ minWidth: 120 }} fullWidth>
                          <TextField
                            size="small"
                            aria-readonly
                            label="Project name"
                            variant="outlined"
                            // value={location?.state?.name || project?.name || projectName}
                            value={project?.name || projectName}
                            disabled
                          />
                        </FormControl>
                      </StyledGrid>
                    </>
                  )}

                  <StyledGrid item xs={6}>
                    <FormControl
                      error={touched.sectionId && Boolean(errors.sectionId)}
                      sx={{ minWidth: 120 }}
                      fullWidth
                      className={classes.select}
                    >
                      <InputLabel>Section</InputLabel>
                      <Select
                        size="small"
                        name="sectionId"
                        {...getFieldProps('sectionId')}
                        label="Section"
                        onChange={(event, value) => {
                          setFieldValue('sectionId', value?.props?.value);
                        }}
                      >
                        {sectionList.map((section) => (
                          <MenuItem value={section.id} key={section.id}>
                            {section.name}
                          </MenuItem>
                        ))}
                        <MenuItem value="" key="add" onClick={hanldeAddSectionClick}>
                          Add New Section
                        </MenuItem>
                      </Select>
                      <FormHelperText error>{touched.sectionId && errors.sectionId}</FormHelperText>
                    </FormControl>
                  </StyledGrid>

                  <StyledGrid item xs={6}>
                    <FormControl sx={{ minWidth: 120 }} fullWidth className={classes.select}>
                      <InputLabel>Task Type</InputLabel>
                      <Select
                        size="small"
                        {...getFieldProps('taskType')}
                        error={touched.status && Boolean(errors.status)}
                        onChange={(e) => {
                          const selectedTaskType = e.target.value;
                          setFieldValue('taskType', selectedTaskType);
                          // Check if the selected task type is "task" or "cr"
                          if (selectedTaskType === 'Task' || selectedTaskType === 'CR') {
                            setFieldValue('parentTaskId', null);
                          }
                        }}
                        label="Task Type"
                      >
                        <MenuItem value="Task">Task</MenuItem>
                        <MenuItem value="Issue">Issue </MenuItem>
                        <MenuItem value="CR">Change Request</MenuItem>
                      </Select>
                      <FormHelperText error>{touched.status && errors.status} </FormHelperText>
                    </FormControl>
                  </StyledGrid>

                  <Grid item xs={6}>
                    <FormControl className={classes.width}>
                      <Autocomplete
                        size="small"
                        variant="outlined"
                        fullWidth
                        options={parentTask}
                        getOptionLabel={(option) => option?.taskName || ''}
                        onInputChange={(event, newInputValue) => {
                          setTaskName(newInputValue);
                        }}
                        value={parentTask.find((option) => option.id === formik.values.parentTaskId) || null}
                        filterOptions={(options, { inputValue }) => {
                          const inputValueLowerCase = inputValue.toLowerCase().trim();
                          return options.filter(
                            (option) =>
                              option?.id.toString().toLowerCase().includes(inputValueLowerCase) ||
                              option?.taskName.toLowerCase().includes(inputValueLowerCase)
                          );
                        }}
                        renderInput={(params) => (
                          <TextField
                            size="small"
                            variant="outlined"
                            {...params}
                            label="Add Parent Task Name"
                            type="text"
                            error={
                              formik.values.taskType === 'Issue' &&
                              formik.touched.parentTaskId &&
                              Boolean(formik.errors.parentTaskId)
                            }
                            helperText={
                              formik.values.taskType === 'Issue' &&
                              formik.touched.parentTaskId &&
                              formik.errors.parentTaskId
                            }
                          />
                        )}
                        onChange={(event, selectedOption) => {
                          formik.setFieldValue(
                            'parentTaskId',
                            selectedOption?.id ? parseInt(selectedOption.id, 10) : null
                          );
                          formik.setFieldValue('parentTask', selectedOption || null);
                        }}
                      />
                      {/* <Autocomplete
                            size="small"
                            variant="outlined"
                            fullWidth
                            options={parentTask}
                            open
                            getOptionLabel={(option) => option?.taskName || ''}
                            value={parentTask.find((option) => option.id === formik.values.parentTaskId) || null}
                            onInputChange={(event, newInputValue) => {
                              setTaskName(newInputValue);
                            }}
                            renderInput={(params) => (
                              <TextField
                                size="small"
                                variant="outlined"
                                {...params}
                                label="Add Parent Task Name"
                                error={formik.touched.parentTaskId && Boolean(formik.errors.parentTaskId)}
                                helperText={formik.touched.parentTaskId && formik.errors.parentTaskId}
                              />
                            )}
                            onChange={(event, selectedOption) => {
                              formik.setFieldValue(
                                'parentTaskId',
                                selectedOption?.id ? parseInt(selectedOption.id, 10) : null
                              );
                              formik.setFieldValue('parentTask', selectedOption || null);
                            }}
                            filterOptions={(options, { inputValue }) => {
                              return options.filter((option) =>
                                option.taskName.toLowerCase().includes(inputValue.toLowerCase())
                              );
                            }}
                          /> */}
                    </FormControl>
                  </Grid>
                  {getFieldProps('taskType').value === 'Issue' && (
                    <Grid item xs={6}>
                      <FormControl className={classes.width}>
                        <Autocomplete
                          size="small"
                          variant="outlined"
                          fullWidth
                          options={['Critical', 'Major', 'Minor']}
                          value={getFieldProps('issueType').value}
                          onChange={(event, newValue) => {
                            setFieldValue('issueType', newValue);
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Issue Type"
                              variant="outlined"
                              error={touched.issueType && Boolean(errors.issueType)}
                              helperText={touched.issueType && errors.issueType}
                            />
                          )}
                        />
                      </FormControl>
                    </Grid>
                  )}

                  <StyledGrid item xs={6}>
                    <FormControl sx={{ minWidth: 120 }} fullWidth className={classes.select}>
                      <InputLabel>Status</InputLabel>
                      <Select
                        size="small"
                        {...getFieldProps('status')}
                        error={touched.status && Boolean(errors.status)}
                        onChange={(e) => {
                          setFieldValue('status', e.target.value);
                        }}
                        label="status"
                      >
                        <MenuItem value="Not Started">Not Started</MenuItem>
                        <MenuItem value="In Progress">In Progress </MenuItem>
                        {action === 'update' && <MenuItem value="Completed">Completed</MenuItem>}
                        {action === 'update' && <MenuItem value="Blocked">Blocked</MenuItem>}
                      </Select>
                      <FormHelperText error>{touched.status && errors.status} </FormHelperText>
                    </FormControl>
                  </StyledGrid>

                  <Grid item xs={6}>
                    <FormControl
                      error={touched.userId && Boolean(errors.userId)}
                      sx={{ minWidth: 120 }}
                      fullWidth
                      className={classes.select}
                    >
                      <InputLabel>Assigned To</InputLabel>
                      <Select
                        size="small"
                        name="userId"
                        label="Assigned To"
                        {...getFieldProps('userId')}
                        onChange={(event, value) => {
                          setFieldValue('userId', value?.props?.value);
                        }}
                        disabled={(selectedTask?.consumedHours > 0 && action === 'update') || isTeamMemberRole}
                      >
                        {isTeamMemberRole ? (
                          <MenuItem value={accountData?.id}>{accountData?.userName}</MenuItem>
                        ) : (
                          employeeList.map((employee) => (
                            <MenuItem value={employee.id} key={employee.id}>
                              {employee.userName}
                            </MenuItem>
                          ))
                        )}
                        {!isTeamMemberRole && (
                          <MenuItem value="" key="add" onClick={hanldeAddMemberClick}>
                            Add New Member
                          </MenuItem>
                        )}
                      </Select>
                      <FormHelperText error>{touched.userId && errors.userId}</FormHelperText>
                    </FormControl>
                  </Grid>

                  <Grid item xs={6}>
                    <FormControl className={classes.width}>
                      <TextField
                        size="small"
                        value={formik.values.plannedHours || ''}
                        label="Planned Hours"
                        placeholder="Add planned hours"
                        variant="outlined"
                        type="number"
                        fullWidth
                        error={touched.plannedHours && Boolean(errors.plannedHours)}
                        helperText={touched.plannedHours && errors.plannedHours}
                        onWheel={(e) => e.target.blur()}
                        onChange={(e) => {
                          const inputValue = e.target.value;
                          const isValidInput = /^-?\d*\.?\d*$/.test(inputValue); // Check if input matches the pattern for valid decimal/float values
                          if (isValidInput && inputValue >= 0) {
                            // Check if input is valid and not negative
                            setFieldValue('plannedHours', inputValue ? parseFloat(inputValue, 10) : undefined);
                          }

                          e.stopPropagation();
                        }}
                        autoComplete="off"
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={6}>
                    <FormControl component="fieldset" className={classes.width}>
                      <RadioGroup
                        row
                        name="isBillable"
                        value={formik.values.isBillable}
                        onChange={formik.handleChange}
                        className={classes.radioSpacing}
                      >
                        <FormControlLabel value control={<Radio />} label="Billable" />
                        <FormControlLabel value={false} control={<Radio />} label="Non-billable" />
                      </RadioGroup>
                      {formik.touched.isBillable && formik.errors.isBillable && (
                        <FormHelperText error>{formik.errors.isBillable}</FormHelperText>
                      )}
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sx={{ pt: '0 !important' }} />

                  <Grid item xs={6}>
                    <FormControl className={classes.width}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Paper>
                          <DatePicker
                            label="Start Date"
                            value={formik.values.startDate}
                            inputFormat="DD MMM YYYY"
                            onChange={(selectedDate) => {
                              // const selectedDate = event.target.value;
                              formik.setFieldValue('startDate', selectedDate);
                            }}
                            minDate={new Date()}
                            renderInput={(params) => (
                              <TextField
                                size="small"
                                fullWidth
                                {...params}
                                {...getFieldProps('startDate')}
                                error={touched.startDate && Boolean(errors.startDate)}
                                helperText={touched.startDate && errors.startDate}
                              />
                            )}
                          />
                        </Paper>
                      </LocalizationProvider>
                    </FormControl>
                  </Grid>

                  <Grid item xs={6}>
                    <FormControl className={classes.width}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Paper>
                          <DatePicker
                            label="End Date"
                            value={formik.values.endDate}
                            inputFormat="DD MMM YYYY"
                            onChange={(selectedDate) => {
                              formik.setFieldValue('endDate', selectedDate);
                            }}
                            minDate={formik.values.startDate ? formik.values.startDate : new Date()}
                            renderInput={(params) => (
                              <TextField
                                size="small"
                                fullWidth
                                {...params}
                                {...getFieldProps('endDate')}
                                error={touched.endDate && Boolean(errors.endDate)}
                                helperText={touched.endDate && errors.endDate}
                              />
                            )}
                          />
                        </Paper>
                      </LocalizationProvider>
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid className={classes.addBtn}>
                  {action === 'create' ? (
                    <LoadingButton
                      type="submit"
                      fullWidth
                      variant="contained"
                      onClick={submitForm}
                      loading={isSubmitting}
                    >
                      Add Task
                    </LoadingButton>
                  ) : (
                    <LoadingButton
                      type="submit"
                      fullWidth
                      variant="contained"
                      onClick={submitForm}
                      loading={isSubmitting}
                    >
                      Update Task
                    </LoadingButton>
                  )}
                </Grid>
              </Stack>
            </Form>
          </FormikProvider>
          <SectionFormModal
            open={addSectionModal}
            onClose={handleCloseAddSection}
            projectId={projectId}
            onSubmit={onAddSection}
          />
          <AddMemberModal
            openModal={addMemberModal}
            onClose={handleCloseAddMember}
            action="create"
            consumedHrs={consumedHrs}
            id={projectId}
            projectDetails={projectDetails}
            onSubmit={onAddMember}
          />
        </Box>
      )}
    </>
  );
}

const modules = {
  toolbar: [
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ['bold', 'italic', 'underline', '', 'blockquote'],
    [{ size: [] }],
    [{ font: [] }],
    [{ align: ['right', 'center', 'justify'] }],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ color: ['red', '#785412', 'black'] }],
  ],
};

const formats = [
  'header',
  'bold',
  'italic',
  'underline',
  '',
  'blockquote',
  'list',
  'bullet',
  'link',
  'color',
  'image',
  'background',
  'align',
  'size',
  'font',
];

const StyledGrid = styled(Grid)(
  () => `
  display:flex;
  align-items:center;
  `
);

const useStyles = makeStyles({
  addBtn: { margin: 'auto !important', width: '75%', marginTop: '2rem !important' },
  quillGrid: {
    '& .quill': {
      width: '100%',
    },
    '& .ql-container': {
      minHeight: '62px',
    },
    '& .ql-toolbar': {
      '& *': {
        tabIndex: -1,
      },
    },
    '& .ql-editor::before': {
      fontStyle: 'normal',
      fontFamily: '"Public Sans", sans-serif',
    },
  },
  select: {
    '& .MuiFormLabel-root': {
      top: '-6px',
    },
  },
  width: { width: '100%' },
  radioSpacing: {
    '& .MuiFormControlLabel-root': {
      marginRight: '32px', // 32px spacing
    },
  },
});

const GroupItems = styled('ul')({
  padding: 0,
});

export default ProjectAddTask;
